import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  collapseContainer: {
    overflowY: 'auto',
  },
});
